import { render, staticRenderFns } from "./ClientCreditHistory.vue?vue&type=template&id=e960af3a"
import script from "./ClientCreditHistory.vue?vue&type=script&lang=js"
export * from "./ClientCreditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports